module.exports = __webpack_public_path__ + "static/media/map-marker.4efff2f2.png";